export default __webpack_public_path__ + "static/5-7d8b208762ba6ef43021594df226d033.png";